module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bdKXw"))).then(() => parcelRequire('f4eak'));